import React, {useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {ModeleGenre, modeleGenreInitValues} from '../../../components/Models'
import {editGenre, getGenre} from '../../../components/requests'
import {LoadingData} from '../../../components/LoadingData'
import {GenreForm} from './components/GenreForm'

const GenreEditPage = () => {
  const navigate = useNavigate();
  let { genreId } = useParams();
  const [data, setData] = useState<ModeleGenre>(modeleGenreInitValues);
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getGenreData()
  }, [genreId]);

  const getGenreData = () => {
    getGenre(genreId).then(genreRequest => {
      if (genreRequest?.status === 200) {
        if (genreRequest?.data?.id !== undefined && genreRequest?.data?.id !== null) {
          const updatedData = Object.assign({...data}, genreRequest?.data)
          setData({...updatedData})
        }
        setLoading(false);
      } else {
        navigate(`/genres`);
      }
    }).catch((e) => {
      setLoading(false);
      navigate(`/genres`);
    });
  }

  const submitForm = async (fieldsToUpdate: Partial<ModeleGenre>, callback): Promise<void> => {
    const updatedData = Object.assign({...modeleGenreInitValues}, fieldsToUpdate)

    var requestOk = false;
    try {
      const genreRequest = await editGenre(genreId, updatedData);
      if (genreRequest?.status === 200) {
        requestOk = true;
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback();
      if (requestOk) {
        setData({...updatedData})
        navigate(`/genres`);
      }
    }
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Modifier un genre</h3>
          </div>
        </div>

        <div>
          {loading
            ?
            <LoadingData />
            :
            <GenreForm utilisateurId={genreId} data={data} submitForm={submitForm}/>
          }
        </div>
      </div>
    </>
  )
}

export {GenreEditPage}
